import React from 'react';

import { Box, Divider, Tab, Tabs } from '@mui/material';

import FontAwesomeIcon from 'features/common/FontAwesomeIcon';
import { dimmed_white_color } from 'theme/cemTheme';

import { AlertTab, TABS } from '../alertConstants';

import styles from './AlertTabs.module.css';

export interface AlertTabsProps {
  activeTab: AlertTab;
  onTabChange: (tab: AlertTab) => void;
  children: React.ReactNode;
  isCreateMode?: boolean;
  completedTabs?: AlertTab[];
  canNavigateTo?: (tab: AlertTab) => boolean;
}

function getTabDisplayName(tab: AlertTab): string {
  switch (tab) {
    case AlertTab.Triggers:
      return 'Triggers';
    case AlertTab.Routes:
      return 'Link Routes';
    case AlertTab.Recipients:
      return 'Email Recipients';
  }
}

export function AlertTabs({
  activeTab,
  onTabChange,
  children,
  isCreateMode = false,
  completedTabs = [],
  canNavigateTo,
}: AlertTabsProps) {
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    onTabChange(TABS[newValue]);
  };

  const tabDisabled = (tab: AlertTab) =>
    canNavigateTo ? !canNavigateTo(tab) : false;

  const getTabLabel = (tab: AlertTab, index: number) => {
    if (!isCreateMode) {
      return getTabDisplayName(tab);
    }

    const stepNumber = index + 1;
    const isCompleted = completedTabs.includes(tab);

    return (
      <Box className={styles.tabLabel}>
        {isCompleted ? (
          <FontAwesomeIcon
            name="circle-check"
            sx={{ color: dimmed_white_color }}
          />
        ) : (
          <Box className={styles.stepNumber}>{stepNumber}</Box>
        )}

        <span>{getTabDisplayName(tab)}</span>
      </Box>
    );
  };

  return (
    <>
      <Box className={styles.tabsContainer}>
        <Tabs value={TABS.indexOf(activeTab)} onChange={handleTabChange}>
          <Tab
            label={getTabLabel(AlertTab.Triggers, 0)}
            disabled={tabDisabled(AlertTab.Triggers)}
          />
          <Tab
            label={getTabLabel(AlertTab.Routes, 1)}
            disabled={tabDisabled(AlertTab.Routes)}
          />
          <Tab
            label={getTabLabel(AlertTab.Recipients, 2)}
            disabled={tabDisabled(AlertTab.Recipients)}
          />
        </Tabs>
      </Box>
      <Divider className={styles.tabDivider} />
      {children}
    </>
  );
}
